<div class="layoutBlock detailpage">
  <!-- Layout Linkpanel linke Seitenspalte leer -->
  <div class="detailpageSideLeft">
  </div>
  <!-- Layout Linkpanel Mitte -->
  <div class="detailpageCenter">
    <!-- Layout Linkpanel Inhalt/Linkblock 2 spaltig -->
    <div class="layoutBlock listviewentryWrap">
      @for (listview of oneListviews; track listview) {
        <his-listviewentry (btnMoreClicked)="this.btnMoreClicked.emit(getListviewKey(listview))"
        [customClickHandler]="customClickHandler" [listview]="listview"></his-listviewentry>
      }

    </div>
  </div> <!-- Ende Layout Linkpanel Mitte -->
  <!-- Layout Linkpanel rechte Spalte -->
  <div class="detailpageSideRight">
    <!--Platzhalter für leere rechte Spalte -->
  </div>
</div>